<template>
    <div>


        <a-row :gutter="24">
            <a-col :span="24" :lg="12" :xl="8" class="mb-24"
                v-for="(stat, index) in stats" :key="index">
                <WidgetCounter :title="stat.title" :value="stat.value" :prefix="stat.prefix" suffix="ريال"
                    :icon="stat.icon" :status="stat.status"></WidgetCounter>
            </a-col>
        </a-row>
    
        <a-row :gutter="24" type="flex" align="stretch">
            <a-col :span="24" :lg="24" class="mb-24">
                <a-card>
                    <a-card-header class="d-flex">
                        <div class="col-md-8">
                            <h6>
                                برترین کاربران
                            </h6>
                        </div>
                        <div class="col-md-7">

                            <div :style="{ marginTop: '16px' }">
                                <a-radio-group v-model="sortBy" size="small">
                                    <a-radio-button value="amountBuy">
                                        میزان خرید
                                    </a-radio-button>
                                    <a-radio-button value="amountSell">
                                        میزان فروش
                                    </a-radio-button>
                                    <a-radio-button value="countBuy">
                                        تعداد خرید
                                    </a-radio-button>
                                    <a-radio-button value="countSell">
                                        تعداد فروش
                                    </a-radio-button>
                                </a-radio-group>
                            </div>
                        </div>

                    </a-card-header>
                    <hr>
                    <div>
                        <section class="w-100 p-4 text-center">
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col">شناسه</th>
                                            <th scope="col">کاربر</th>
                                            <th scope="col">نوع کاربری</th>
                                            <th scope="col">موجودی کیف پول</th>
                                            <th scope="col">موجودی تهاتری</th>
                                            <th scope="col">سرمایه اولیه</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in data">
                                            <th scope="row">#{{ row . id }}</th>
                                            <td>
                                                <b-avatar size="1.5rem"
                                                    :src="$root.image_concat(row.image)"></b-avatar>

                                                <b-badge variant="light" class="text-dark">
                                                    {{ row . firstname + ' ' + row . lastname }}</b-badge>
                                            </td>
                                            <td>
                                                <b-badge v-if="row.type == 'admin'" variant="light"
                                                    class="bg-secondary">
                                                    ادمین</b-badge>
                                                <b-badge v-else-if="row.type == 'legal'" variant="light"
                                                    class="bg-secondary">حقوقی</b-badge>
                                                <b-badge v-else variant="light" class="bg-secondary">حقیقی</b-badge>
                                            </td>

                                            <td>
                                                <b-badge pill variant="info" class="bg-success">
                                                    {{ $root . number_format(row . wallet) }}
                                                </b-badge>
                                            </td>
                                            <td>
                                                <b-badge pill variant="info" class="bg-info">
                                                    {{ $root . number_format(row . barter) }}</b-badge>
                                            </td>
                                            <td>
                                                <b-badge pill variant="info" class="bg-primary">
                                                    {{ $root . number_format(row . investment) }}</b-badge>
                                            </td>
                                            <td>
                                                <a-button class="btn-outline-primary" shape="square"
                                                    v-show="$root.hasPermission('/users/detail/')"
                                                    :href="'/users/detail/' + row.id">اطلاعات مالی</a-button>
                                                &nbsp;

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>

                    </div>
                </a-card>
            </a-col>
        </a-row>

    </div>
</template>

<script>


    // Bar chart for "Active Users" card.
    import CardBarChart from '../../components/Cards/CardBarChart';

    // Line chart for "Sales Overview" card.
    import CardLineChart from '../../components/Cards/CardLineChart';

    // Counter Widgets
    import WidgetCounter from '../../components/Widgets/WidgetCounter';

    // "Projects" table component.
    import CardProjectTable from '../../components/Cards/CardProjectTable';

    // Order History card component.
    import CardOrderHistory from '../../components/Cards/CardOrderHistory';

    // Information card 1.
    import CardInfo from '../../components/Cards/CardInfo';

    // Information card 2.
    import CardInfo2 from '../../components/Cards/CardInfo2';

    // Counter Widgets stats
    const stats = [{
            title: " کل موجودی نقدی کاربران",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z" fill="#111827"/>
							<path d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z" fill="#111827"/>
							<path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z" fill="#111827"/>
						</svg>`,
        },
        {
            title: "کل موجودی تهاتری کاربران",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
        },
        {
            title: " جمع میزان سود های واریز شده  ",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
        },
        {
            title: "فروش   تهاتری روزانه",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
        },
        {
            title: "فروش   تهاتری هفتگی",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
        },
        {
            title: "فروش   تهاتری ماهیانه",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
        },

        {
            title: "فروش   نقدی روزانه",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
        },
        {
            title: "فروش   نقدی هفتگی",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
        },
        {
            title: "فروش   نقدی ماهیانه",
            value: "0",
            icon: `
						<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
        },

    ];

    // "Projects" table list of columns and their properties.
    const tableColumns = [{
            title: 'شرکت ها',
            dataIndex: 'company',
            scopedSlots: {
                customRender: 'company'
            },
            width: 300,
        },
        {
            title: 'اعضا',
            dataIndex: 'members',
            scopedSlots: {
                customRender: 'members'
            },
        },
        {
            title: 'بودجه',
            dataIndex: 'budget',
            class: 'font-bold text-muted text-sm',
        },
        {
            title: 'تکمیل',
            scopedSlots: {
                customRender: 'completion'
            },
            dataIndex: 'completion',
        },
    ];

    // "Projects" table list of rows and their properties.
    const tableData = [{
            key: '1',
            company: {
                name: 'اسپاتیفای',
                logo: 'images/logos/logo-shopify.svg',
            },
            members: ["images/face-1.jpg", "images/face-4.jpg", "images/face-2.jpg", "images/face-3.jpg", ],
            budget: '۱۴،۰۰۰ تومان',
            completion: 60,
        },
        {
            key: '2',
            company: {
                name: 'نمودار پیشرفت',
                logo: 'images/logos/logo-atlassian.svg',
            },
            members: ["images/face-4.jpg", "images/face-3.jpg", ],
            budget: '۳،۰۰۰،۰۰۰ تومان',
            completion: 10,
        },
        {
            key: '3',
            company: {
                name: 'برطرف کردن ارور های پلتفرم',
                logo: 'images/logos/logo-slack.svg',
            },
            members: ["images/face-1.jpg", "images/face-2.jpg", "images/face-3.jpg", ],
            budget: '-',
            completion: {
                label: '100',
                status: 'success',
                value: 100,
            },
        },
        {
            key: '4',
            company: {
                name: 'راه اندازی اپلیکیشن موبایل',
                logo: 'images/logos/logo-spotify.svg',
            },
            members: ["images/face-1.jpg", "images/face-2.jpg", ],
            budget: '۲۰،۶۰۰،۰۰۰',
            completion: {
                label: '100',
                status: 'success',
                value: 100,
            },
        },
        {
            key: '5',
            company: {
                name: 'اضافه کردن لندینگ جدید',
                logo: 'images/logos/logo-jira.svg',
            },
            members: ["images/face-1.jpg", "images/face-4.jpg", "images/face-2.jpg", "images/face-3.jpg", ],
            budget: '۴،۰۰۰،۰۰۰',
            completion: 80,
        },
        {
            key: '6',
            company: {
                name: 'طراحی دوباره فروشگاه آنلاین',
                logo: 'images/logos/logo-invision.svg',
            },
            members: ["images/face-1.jpg", "images/face-4.jpg", "images/face-3.jpg", ],
            budget: '۲،۰۰۰،۰۰۰',
            completion: {
                label: 'Cancelled',
                status: 'exception',
                value: 100,
            },
        },
    ];
    import {
        mapActions
    } from 'vuex'

    export default ({
        components: {
            CardBarChart,
            CardLineChart,
            WidgetCounter,
            CardProjectTable,
            CardOrderHistory,
            CardInfo,
            CardInfo2
        },
        mounted() {
            this.getData();
            this.getReport();
        },
        data() {
            return {
                data: [],
                currentPage: 1,
                total: 0,
                // Associating table data with its corresponding property.
                tableData,

                // Associating table columns with its corresponding property.
                tableColumns,

                // Counter Widgets Stats
                stats,
                sortBy: '',
                report: {}
            }
        },

        methods: {
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url = `/users/sort?sortBy=${this.sortBy}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = [];
                        _this.data = response.data;
                        _this.$store.state.loading = false;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getReport() {
                let _this = this;
                this.$store.state.loading = true;
                let url = `/users/report`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.report = response.data.data
                        _this.stats[0].value = _this.report.wallet
                        _this.stats[1].value = _this.report.barter
                        _this.stats[2].value = _this.report.profits
                        _this.stats[3].value = _this.report.barter_daily
                        _this.stats[4].value = _this.report.barter_weekly
                        _this.stats[5].value = _this.report.barter_monthly
                        _this.stats[6].value = _this.report.cash_daily
                        _this.stats[7].value = _this.report.cash_weekly
                        _this.stats[8].value = _this.report.cash_monthly


                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

        },
        watch: {
            sortBy() {
                this.getData();
            }
        }
    })
</script>

<style lang="scss">
</style>
